export default "__VITE_ASSET__DmV2yy_E__"